import React from 'react';
import PropTypes from 'prop-types';

function CustomLabelText({ x, y, text, color, bold, atEnd }) {
  const condProp = {
    fontWeight: 'bold',
    textAnchor: 'end'
  };
  if (!bold) condProp.fontWeight = undefined;
  if (!atEnd) condProp.textAnchor = 'middle';
  return (
    <text x={x} y={y} fontSize="10px" alignmentBaseline="central" fill={color} {...condProp}>
      {text}
    </text>
  );
}

CustomLabelText.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  color: PropTypes.string.isRequired,
  bold: PropTypes.bool,
  atEnd: PropTypes.bool
};

export default CustomLabelText;
